var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stars",
    clipPath: "url(#clip0_1122_76434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99337 1.33551C4.31337 1.33551 1.33337 4.32218 1.33337 8.00218C1.33337 11.6822 4.31337 14.6688 7.99337 14.6688C11.68 14.6688 14.6667 11.6822 14.6667 8.00218C14.6667 4.32218 11.68 1.33551 7.99337 1.33551ZM10.82 12.0022L8.00004 10.3022L5.18004 12.0022L5.92671 8.79551L3.44004 6.64218L6.72004 6.36218L8.00004 3.33551L9.28004 6.35551L12.56 6.63551L10.0734 8.78884L10.82 12.0022Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_76434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor",
    transform: "translate(0 0.00219727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCircle);
export default __webpack_public_path__ + "static/media/star-circle.29f60b9f9b088ad62bb446918b9b4e4e.svg";
export { ForwardRef as ReactComponent };